export default (store) => {
  const ability = store.getters.ability
  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'user/SET_RULES':
        ability.update(mutation.payload)
        break
    }
  })
}
